import React from 'react'
import Loading from "../../components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";


const DesktopFineDine = dynamic(() => import('../../components/restaurants/foodTruck/DesktopFoodTruck'), {
  loading: () => <Loading />,

});
const MobileFineDine = dynamic(() => import('../../components/restaurants/foodTruck/MobileFoodTruck'), {
  loading: () => <Loading />,

});

const foodTruck = ({ mobileView }) => {
  return (
    <>
      <Head>
        <title>Food Truck POS Billing Software & Management Solutions</title>
        <link rel="canonical" href="https://queuebuster.co/restaurants/food-truck-pos-billing-software" />
        <link rel="alternate" href="https://queuebuster.co/restaurants/food-truck-pos-billing-software" hrefLang="en-us" />
        <meta name="description" content="Elevate your food truck business with tailored POS billing software and comprehensive food truck management solutions. Call Us & Book a Free Demo." />
        <meta property="og:title" content="Food Truck POS Billing Software & Food Truck  Management Solutions" />
        <meta property="og:description" content="Elevate your food truck business with tailored POS billing software and comprehensive management solutions. Efficiently manage orders, track inventory, and enhance customer service on-the-go with our QueueBuster POS." />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/assets/outlet-og-img/food-truck.jpg" />
        <meta property="og:url" content="https://queuebuster.co/restaurants/food-truck-pos-billing-software" />
      </Head>
         <SchemaTags page="food-truck-pos-billing-software" />
      {
        mobileView ? <MobileFineDine /> : <DesktopFineDine />
      }
    </>
  )
}

export default foodTruck